import { AbstractControl, ValidationErrors } from "@angular/forms";

export class CustomValidators {
    public static required(control: AbstractControl): ValidationErrors | null {
        return control.value ? null : { required: true };
    }

    public static future(control: AbstractControl): ValidationErrors | null {
        const today = new Date().getMidnight();
        const selectedDate = new Date(control.value);
        return selectedDate.isEarlier(today, false, true) ? { notFutureDate: true } : null;
    }

    public static dateRange(startKey: string, endKey: string) {
        return (group: AbstractControl): ValidationErrors | null => {
        const start = group.get(startKey)?.value;
        const end = group.get(endKey)?.value;
        if (!start || !end) return null;
        return new Date(end) >= new Date(start) ? null : { dateRangeInvalid: true };
        };
    }
}